import { atom } from "recoil";

export const ProjectListAtom = atom({
    key: 'projectListState',
    default: [],
});

export const ProjectModifyAtom = atom({
    key: 'projectModifyState',
    default: [],
});

export const ProjectEditAtom = atom({
    key: 'projectEditState',
    default: false,
});